const resources = {
    relatedContentLabel: 'Contenu relié',
    exploreMoreLabel: 'Découvrir plus'
};

export default function getResource(label) {
    return resources[label];
}
